export const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'

export const GET_TOP_HOLDERS_REQUEST = 'GET_TOP_HOLDERS_REQUEST'
export const GET_TOP_HOLDERS_SUCCESS = 'GET_TOP_HOLDERS_SUCCESS'
export const GET_TOP_HOLDERS_FAILURE = 'GET_TOP_HOLDERS_FAILURE'

export const GET_PRESALE_REQUEST = 'GET_PRESALE_REQUEST'
export const GET_PRESALE_SUCCESS = 'GET_PRESALE_SUCCESS'
export const GET_PRESALE_FAILURE = 'GET_PRESALE_FAILURE'

export const SET_DEFAULT_DASHBOARD = 'SET_DEFAULT_DASHBOARD'
export const SET_DEFAULT_TOP_HOLDERS = 'SET_DEFAULT_TOP_HOLDERS'
